import React from "react"
import { selectConversation, useAssistantStore } from "../assistantStore"
import { AssistantScreenProvider } from "../screenRegistry"
import { useAssistantStatus } from "../useAssistant"
import AssistantPanel from "./AssistantPanel.component"

/** The panel, mounted only while open, and only for an organisation that has the assistant. */
const DockedPanel: React.FC = () => {
  const { enabled } = useAssistantStatus()
  if (!enabled) return null
  return (
    <aside className="w-[380px] shrink-0 h-full min-h-0 border-l border-gray-200 bg-white">
      <AssistantPanel />
    </aside>
  )
}

/**
 * A reporting page with the assistant: the page (`children`) and, while the
 * panel is open, the panel docked on the right. Provides the project and the
 * screen registration to everything inside, so the page registers itself
 * with `useRegisterAssistantScreen` and places an `AssistantToggle`.
 */
const AssistantDock: React.FC<{
  projectId: string
  owner: string
  children?: React.ReactNode
}> = ({ projectId, owner, children }) => {
  const open = useAssistantStore((s) => selectConversation(projectId)(s).open)
  return (
    <AssistantScreenProvider projectId={projectId} owner={owner}>
      <div className="flex h-full min-h-0 w-full">
        <div className="flex-1 min-w-0 h-full">{children}</div>
        {open && <DockedPanel />}
      </div>
    </AssistantScreenProvider>
  )
}

export default AssistantDock
